import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import QueryManagementCompanies from 'graphql/queries/management/QueryManagementCompanies'
import store from 'services/redux/store'
import { setManagement } from 'services/redux/management/actions'
import { managementConstants } from 'services/redux/management/constants'

export default class FetchManagementCompany {
	
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {}, dispatchDataToStore = true } = {} ) {
		new GraphqlBuilder()
			.addQuery( 'companies', QueryManagementCompanies, variables )
			.setResultPath( ['companies', 'companies'], []  )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				
				if( dispatchDataToStore ) {
					store.dispatch( setManagement( managementConstants.COMPANIES, result ) )
				}
				
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						companies: result
					});
				}
			})
			.execute()
	}
}
